export const TYPE_STANDARD = 'standard'
export const TYPE_ENHANCED = 'enhanced'

export const USE_CASE_2FA = '2FA'
export const USE_CASE_ACCOUNT_NOTIFICATION = 'ACCOUNT_NOTIFICATION'
export const USE_CASE_AGENTS_FRANCHISES = 'AGENTS_FRANCHISES'
export const USE_CASE_CARRIER_EXEMPT = 'CARRIER_EXEMPT'
export const USE_CASE_CHARITY = 'CHARITY'
export const USE_CASE_CUSTOMER_CARE = 'CUSTOMER_CARE'
export const USE_CASE_DELIVERY_NOTIFICATION = 'DELIVERY_NOTIFICATION'
export const USE_CASE_EMERGENCY = 'EMERGENCY'
export const USE_CASE_FRAUD_ALERT = 'FRAUD_ALERT'
export const USE_CASE_HIGHER_EDUCATION = 'HIGHER_EDUCATION'
export const USE_CASE_K12_EDUCATION = 'K12_EDUCATION'
export const USE_CASE_LOW_VOLUME = 'LOW_VOLUME'
export const USE_CASE_MARKETING = 'MARKETING'
export const USE_CASE_MIXED = 'MIXED'
export const USE_CASE_POLITICAL = 'POLITICAL'
export const USE_CASE_POLLING_VOTING = 'POLLING_VOTING'
export const USE_CASE_PROXY = 'PROXY'
export const USE_CASE_PUBLIC_SERVICE_ANNOUNCEMENT = 'PUBLIC_SERVICE_ANNOUNCEMENT'
export const USE_CASE_SECURITY_ALERT = 'SECURITY_ALERT'
export const USE_CASE_SOCIAL = 'SOCIAL'
export const USE_CASE_SOLE_PROPRIETOR = 'SOLE_PROPRIETOR'
export const USE_CASE_SWEEPSTAKE = 'SWEEPSTAKE'

export const USE_CASE_CATEGORIES = [
    {value: USE_CASE_2FA, label: '2FA'},
    {value: USE_CASE_ACCOUNT_NOTIFICATION, label: 'Account Notification'},
    {value: USE_CASE_AGENTS_FRANCHISES, label: 'Agents & Franchises'},
    {value: USE_CASE_CARRIER_EXEMPT, label: 'Carrier Exempt'},
    {value: USE_CASE_CHARITY, label: 'Charity'},
    {value: USE_CASE_CUSTOMER_CARE, label: 'Customer Care'},
    {value: USE_CASE_DELIVERY_NOTIFICATION, label: 'Delivery Notification'},
    {value: USE_CASE_EMERGENCY, label: 'Emergency'},
    {value: USE_CASE_FRAUD_ALERT, label: 'Fraud Alert'},
    {value: USE_CASE_HIGHER_EDUCATION, label: 'Higher Education'},
    {value: USE_CASE_K12_EDUCATION, label: 'K-12 Education'},
    {value: USE_CASE_LOW_VOLUME, label: 'Low Volume'},
    {value: USE_CASE_MARKETING, label: 'Marketing'},
    {value: USE_CASE_MIXED, label: 'Mixed'},
    {value: USE_CASE_POLITICAL, label: 'Political'},
    {value: USE_CASE_POLLING_VOTING, label: 'Polling & Voting'},
    {value: USE_CASE_PROXY, label: 'Proxy'},
    {value: USE_CASE_PUBLIC_SERVICE_ANNOUNCEMENT, label: 'Public Service Announcement'},
    {value: USE_CASE_SECURITY_ALERT, label: 'Security Alert'},
    {value: USE_CASE_SOCIAL, label: 'Social'},
    {value: USE_CASE_SOLE_PROPRIETOR, label: 'Sole Proprietor'},
    {value: USE_CASE_SWEEPSTAKE, label: 'Sweepstake'},
]
